export default __webpack_public_path__ + "static/media/tv.0049bc70.png";